// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css'; // You would need to create this file with the Tailwind imports
import App from './App';

// Get the root element
const rootElement = document.getElementById('root');
// Create a root
const root = createRoot(rootElement);
// Render your app
root.render(
    <App />
);

// src/index.css - Create this file with Tailwind imports
/*
@tailwind base;
@tailwind components;
@tailwind utilities;
*/